import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalComponent } from 'src/app/private/shared/components/modals/modal/modal.component';
import { ProformViewStates } from 'src/app/private/shared/dtos/proforms.dto';
import {
  ProFormContext,
  ProFormsSubmissionAPIResponse,
} from 'src/app/private/shared/types/responses/proforms.responses';

@Component({
  selector: 'app-proforms-view-form-page',
  standalone: false,
  templateUrl: './proforms-view-form-page.component.html',
  styleUrl: './proforms-view-form-page.component.scss',
})
export class ProformsViewFormPageComponent implements OnInit {
  @ViewChild('gradedQuizModal')
  gradedQuizModal: ModalComponent;

  isLoading = false;

  formId = 0;

  viewStates = ProformViewStates;

  submission: ProFormsSubmissionAPIResponse | null = null;

  contextType = ProFormContext.SELF;

  gradedFormId: number | null = null;

  gradedSubmissionId: number | null = null;

  constructor(private route: ActivatedRoute) {}

  onFormSubmit(submission: ProFormsSubmissionAPIResponse) {
    this.submission = submission;
  }

  openGradedQuizModal(event: { formId: number; submissionId: number }) {
    this.gradedFormId = event.formId;
    this.gradedSubmissionId = event.submissionId;
    this.gradedQuizModal.open();
  }

  ngOnInit(): void {
    // APPLY BACKGROUND IMAGE
    document.body.classList.add('proform');

    this.route.params.subscribe((url) => {
      this.formId = url['formId'];
    });
  }
}
